module.exports = __webpack_public_path__ + "static/media/sao-paulo-sp.9b644cf6.jpg";